// extracted by mini-css-extract-plugin
module.exports = {"skeleton-grid":"styles_skeleton-grid__28OIs","skeleton-row":"styles_skeleton-row__3T8oX","loading":"styles_loading__2gyL9"};